import React from 'react';
import { SubCategoryProps } from '../views/SubCategory/SubCategory';
import { BreadcrumbItemProps } from '../components/Breadcrumbs/Breadcrumbs';
import { categoryLandingPageToBreadcrumbs } from './contentfulApiCategoryLandingPageToCategoryLandingProps';
import { contentfulApiThemeToContentThemeProps, ContentTheme } from './contentfulApiThemeToContentThemeProps';
import { contentfulApiFeaturedBannerToCardProps } from './contentfulApiFeaturedBannerToCardProps';
import { ContentfulSubCategoryPage } from '@jbhi-fi/apis/src/contentful/types';
import { HeroBlockHeading } from '@jbhi-fi/components/src/HeroBlock';
import { CardTransformer } from '@jbhi-fi/components/src/Contentful/transformers/CardTransformer';

export const contentfulApiSubCategoryPageToSubCategoryProps = (
  subCategoryPage: ContentfulSubCategoryPage
): SubCategoryProps => {
  const { fields } = subCategoryPage;
  const theme = subCategoryPageToContentTheme(subCategoryPage);

  return {
    hero: fields
      ? {
          heading: (
            <HeroBlockHeading
              content={fields.heading}
              color={theme?.textColor}
              icon={theme?.icon}
              fontFamily="dom_casual"
              isIconStacked={{ xs: true, md: false }}
            />
          ),
        }
      : undefined,
    breadcrumbs: {
      items: subCategoryPageToBreadcrumbs(subCategoryPage),
      colorHex: theme?.textColor,
    },
    pageTitle: fields?.heading,
    theme,
    featuredBannerProps: fields?.featuredBanner?.fields
      ? contentfulApiFeaturedBannerToCardProps(fields.featuredBanner)
      : undefined,
    cardsFilter: subCategoryPage?.sys?.id
      ? {
          'fields.subCategoryPage.sys.id': subCategoryPage?.sys?.id,
        }
      : undefined,
    pinnedCards: fields?.pinnedArticles?.map(article => CardTransformer.toCardProps(article)),
    pinnedCardsHeading: fields?.pinnedArticlesHeading,
  };
};

const subCategoryPageToContentTheme = ({ fields }: ContentfulSubCategoryPage): ContentTheme | undefined => {
  const categoryTheme: ContentTheme | undefined = fields?.categoryPage?.fields?.heroTheme?.fields
    ? contentfulApiThemeToContentThemeProps(fields?.categoryPage?.fields?.heroTheme)
    : undefined;
  const subCategoryTheme: ContentTheme | undefined = fields?.themeColour?.fields
    ? contentfulApiThemeToContentThemeProps(fields.themeColour)
    : undefined;

  return categoryTheme || subCategoryTheme
    ? {
        textColor: (subCategoryTheme?.textColor ?? categoryTheme?.textColor) as string,
        backgroundColor: (subCategoryTheme?.backgroundColor ?? categoryTheme?.backgroundColor) as string,
        icon: categoryTheme?.icon,
      }
    : undefined;
};

const subCategoryPageToBreadcrumbs = ({ fields }: ContentfulSubCategoryPage): Array<BreadcrumbItemProps> => {
  if (!fields) return [];
  const categoryLandingItems = fields.categoryPage ? categoryLandingPageToBreadcrumbs(fields.categoryPage) : [];
  return [
    ...categoryLandingItems.map(item => ({ ...item, isActive: false })),
    {
      href: `${categoryLandingItems[categoryLandingItems.length - 1].href}/${fields.urlSlug}`,
      label: fields.heading,
      isActive: true,
    },
  ];
};
